import 'core-js/stable'
import Vue from 'vue'
import CoreuiVue from '@coreui/vue/src'
import App from './App'
import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import { message } from './assets/js/resetMessage'
import store from './store'
import './assets/icon/iconfont.css' //字体
import $ from 'jquery'

import axios from '@/http'
Vue.prototype.$http = axios

//注册到vue原型上
import clipboard from 'clipboard'
Vue.prototype.clipboard = clipboard

import ElementUI from 'element-ui'
ElementUI.Dialog.props.closeOnClickModal.default = false
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import VueI18n from 'vue-i18n'
import LangEn from '../static/lang/en'
import LangZhCHS from '../static/lang/zhchs'
import LangZhCHT from '../static/lang/zhcht'
Vue.use(VueI18n)
const bus = new Vue()
import event from './views/public/event'
Vue.prototype.EVENT = event
Vue.prototype.$message = message
const i18n = new VueI18n({
  locale: 'zhchs',
  messages: {
    en: LangEn,
    zhchs: LangZhCHS,
    zhcht: LangZhCHT,
  },
})
i18n.locale = store.state.lang

Vue.use(CoreuiVue)

// postMessage 通信 主要是语音控制这一块
import wsMsgEvent from '@/utils/wsMsgEvent'
Vue.prototype.$bus = bus
Vue.prototype.wsMsgEvent = wsMsgEvent

// svg图标
import './icons' // icon

import { createTUICallEngine } from '@/plugins/TimTUICall'
// 这个有bug 后续有时间再研究
// import TimTUICallTes from '@/plugins/TimTUICallTes'
// Vue.prototype.$timCall = new TimTUICallTes()
const {
  tim,
  tuiCallEngine,
  TUICallEvent,
  TUICallType,
  genTestUserSig,
} = createTUICallEngine()
Vue.prototype.$tim = tim
Vue.prototype.$tuiCallEngine = tuiCallEngine
Vue.prototype.TUICallEvent = TUICallEvent
Vue.prototype.TUICallType = TUICallType
Vue.prototype.genTestUserSig = genTestUserSig

import autoLogin from '@/minixs/h5sWebLogin/autoLogin'
let anonymity = localStorage.getItem('anonymity')
router.beforeEach((to, from, next) => {
  const type = to.meta.type
  if (to.query['embed'] == 'true') {
    if (store.state.root && store.state.token) {
      next()
    } else {
      // 自动登录
      autoLogin.login(to, from, next)
    }

    // else if (to.query['embed'] == 'false' && to.query['autoLogin'] == 'true') {
    //   if (store.state.root && store.state.token) {
    //     next()
    //   } else {
    //     // 自动登录
    //     autoLogin.login(to, from, next)
    //   }
    // } 
  } else {
    // 判断该路由是否需要登录权限
    if (store.state.root != null) {
      if (store.state.token) {
        if (store.state.root === 'Administrator') {
          next()
        } else {
          if (store.state.root === 'Operator' && type === 'Operator') {
            next()
          } else {
            sessionStorage.removeItem('mcutoken')
            store.state.token = null
            sessionStorage.removeItem('mcuuser')
            store.state.user = null
            sessionStorage.removeItem('mcuroot')
            store.state.root = null
            next('/login')
          }
        }
      } else {
        sessionStorage.removeItem('mcutoken')
        store.state.token = null
        sessionStorage.removeItem('mcuuser')
        store.state.user = null
        sessionStorage.removeItem('mcuroot')
        store.state.root = null
        next('/login')
      }
    } else {
      if (anonymity == 'false') {
        if (to.path === '/login') {
          next()
        } else {
          next('./login')
        }
      } else {
        next()
      }
    }
  }
})

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  template: '<App/>',
  data: {
    bus,
  },
  components: {
    App,
  },
})
